<template>
  <div class="floating-menu" :class="{ open: isOpen }">
    <!-- Toggle button on mobile -->
    <button
      class="floating-menu__toggle"
      @click="toggleOpen"
      :aria-label="isOpen ? 'Cerrar menú' : 'Abrir menú'"
      type="button"
    >
      <a-icon :type="isOpen ? 'close' : 'menu'" />
    </button>

    <!-- Icons container -->
    <div class="floating-menu__list">
      <router-link
        class="floating-menu__icon"
        :to="{ name: 'home' }"
        title="Inicio"
        @click.native="closeMobile"
      >
        <a-icon type="home" />
      </router-link>
      <router-link
        class="floating-menu__icon"
        :to="{ name: 'transaction-request' }"
        title="Transacciones"
        @click.native="closeMobile"
      >
        <a-icon type="swap" />
      </router-link>
      <router-link
        class="floating-menu__icon"
        :to="{ name: 'buy' }"
        title="Jugar"
        @click.native="closeMobile"
      >
        <a-icon type="shopping-cart" />
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "FloatingMenu",
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    toggleOpen() {
      this.isOpen = !this.isOpen;
    },
    closeMobile() {
      this.isOpen = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/scss/variable";

.floating-menu {
  position: fixed;
  z-index: 1000;
  top: 20px;
  right: 20px;

  &__toggle {
    display: none; /* Hidden on desktop */
  }

  &__list {
    display: flex;
    flex-direction: column;
  }

  &__icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 50px;
    height: 50px;
    margin-bottom: 10px;
    background: var(--primary);
    border-radius: 50%;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    color: var(--white);
    transition: background 0.3s, color 0.3s, transform 0.2s ease;

    &:hover {
      background: var(--hover);
      color: var(--white);
      text-decoration: none;
      transform: scale(1.05);
    }

    .anticon {
      font-size: 24px;
    }
  }

  /* Responsive for mobile */
  @media screen and (max-width: $screen-mobile) {
    top: 12px;
    right: 12px;

    &__toggle {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 40px;
      height: 40px;
      background: var(--primary);
      border: none;
      border-radius: 50%;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
      color: var(--white);
      cursor: pointer;
      font-size: 18px;
      transition: all 0.3s ease;
      margin-bottom: 8px;
      margin-left: auto;

      &:focus {
        outline: none;
      }
      &:active {
        transform: scale(0.95);
      }
    }

    &__list {
      display: none;
      flex-direction: column;
      align-items: flex-end;
    }

    &.open {
      .floating-menu__list {
        display: flex;
        animation: fadeInDown 0.25s ease forwards;
      }
    }

    &__icon {
      width: 40px;
      height: 40px;
      margin-bottom: 8px;

      .anticon {
        font-size: 18px;
      }
    }
  }
}

@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
